/**
 * Niños (sección 4): tabla global (nombre, edad, padre, terapeutas vinculados,
 * nº baterías) + búsqueda. El nº de baterías se cruza en el cliente con el
 * listado global de baterías (viven en assessment, otro módulo). Solo lectura.
 */
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminApi } from "../../api/endpoints.js";
import { useQuery } from "../../hooks/useQuery.js";
import { Async, edadDesde } from "./ui.js";
import s from "./admin.module.css";

export function AdminChildren() {
  const navigate = useNavigate();
  const q = useQuery(() => adminApi.ninos());
  // Para el nº de baterías por niño (cruce cliente; assessment es otro módulo).
  const bat = useQuery(() => adminApi.baterias({ limit: 200 }));
  const [busqueda, setBusqueda] = useState("");

  const conteoBaterias = useMemo(() => {
    const m = new Map<string, number>();
    for (const b of bat.data?.items ?? []) m.set(b.childId, (m.get(b.childId) ?? 0) + 1);
    return m;
  }, [bat.data]);

  const filtrados = useMemo(() => {
    const t = busqueda.trim().toLowerCase();
    const lista = q.data ?? [];
    if (!t) return lista;
    return lista.filter(
      (n) =>
        n.nombre.toLowerCase().includes(t) ||
        (n.padre?.nombre ?? "").toLowerCase().includes(t) ||
        (n.padre?.email ?? "").toLowerCase().includes(t),
    );
  }, [q.data, busqueda]);

  return (
    <>
      <div className={s.toolbar}>
        <input
          className={s.search}
          placeholder="Buscar por niño o padre…"
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
        />
        <span className={s.count}>{filtrados.length} niños</span>
      </div>

      <div className={s.panel}>
        <Async q={q}>
          {() => (
            <div className={s.tableWrap}>
              <table className={s.table}>
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Edad</th>
                    <th>Padre</th>
                    <th>Terapeutas</th>
                    <th>Baterías</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {filtrados.map((n) => (
                    <tr
                      key={n.id}
                      className={s.rowClickable}
                      onClick={() => navigate(`/admin/ninos/${n.id}`)}
                    >
                      <td>{n.nombre}</td>
                      <td className={s.muted}>{edadDesde(n.fechaNacimiento)}</td>
                      <td>
                        {n.padre ? (
                          <>
                            {n.padre.nombre}
                            <div className={s.mono}>{n.padre.email}</div>
                          </>
                        ) : (
                          <span className={s.muted}>—</span>
                        )}
                      </td>
                      <td>
                        {n.terapeutas.length === 0 ? (
                          <span className={s.muted}>—</span>
                        ) : (
                          n.terapeutas.map((t) => t.nombre).join(", ")
                        )}
                      </td>
                      <td>{conteoBaterias.get(n.id) ?? 0}</td>
                      <td className={s.muted}>›</td>
                    </tr>
                  ))}
                  {filtrados.length === 0 ? (
                    <tr>
                      <td colSpan={6} className={s.empty}>
                        Sin niños que coincidan.
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            </div>
          )}
        </Async>
      </div>
    </>
  );
}
